<template>
    <div v-if="isVisiable" id="invoice-detail-discount-view" class="detail-card red">
        <div class="card-header">
            <div class="title">銷貨折讓</div>
            <div>
                <el-button v-if="isShowEditButton" style="margin-left: 10px; color: #888" size="mini" @click="onEdit">編輯</el-button>
                <el-button v-if="isShowReturnButton" size="mini" type="danger" plain @click="$emit('addReturn', invoice.foO_DIS_AMT)">新增退款</el-button>
            </div>
        </div>
        <div class="card-body">
            <el-row :gutter="40" v-if="!isEditing">
                <el-col :sm="14">
                    <spec-view>
                        <spec-item label="折讓日期">
                            {{ invoice.foO_DIS_DAT | dateFormater("YYYY-MM-dd") }}
                        </spec-item>
                        <spec-item label="折讓金額">
                            <Money :v="invoice.foO_DIS_AMT" style="color: red" />
                        </spec-item>
                        <spec-item label="折讓稅額">
                            <Money :v="invoice.foO_DIS_AMT_TAX" />
                        </spec-item>
                        <spec-item label="折讓原因">
                            {{ invoice.foO_DIS_MEM }}
                        </spec-item>
                    </spec-view>
                </el-col>
                <el-col :sm="10">
                    <spec-view>
                        <spec-item label="編輯人">
                            {{ invoice.foO_DIS_CRT_NAM }}
                        </spec-item>
                        <spec-item label="編輯日期">
                            {{ invoice.foO_DIS_CRT_DAT | dateFormater("YYYY-MM-dd") }}
                        </spec-item>
                        <spec-item label="營業稅申報" v-if="isDiscountDeclared">
                            <el-tag type="success" size="small">
                                <i class="el-icon-check" />
                                <span>已申報</span>
                                <span>{{ getPeriodText(invoice.foO_DIS_PREFIX_YER, invoice.foO_DIS_PREFIX_MONTH) }}</span>
                            </el-tag>
                        </spec-item>
                    </spec-view>
                </el-col>
            </el-row>
            <div v-if="isEditing">
                <el-form :model="editForm" :rules="editRules" ref="editForm" label-position="left" label-width="150px" size="small">
                    <el-form-item prop="foO_DIS_DAT" label="折讓日期">
                        <el-date-picker
                            v-model="editForm.foO_DIS_DAT"
                            value-format="timestamp"
                            type="date"
                            placeholder="請選擇"
                            :picker-options="{ disabledDate }"
                            :disabled="isDiscountDeclared"
                        ></el-date-picker>
                    </el-form-item>
                    <el-form-item prop="foO_DIS_AMT" label="折讓金額">
                        <div style="display: flex">
                            <MoneyInput v-model="editForm.foO_DIS_AMT" prepend="–" :precision="invoice.cny == 'TWD' ? 0 : 2" style="flex: 1; margin-right: 10px" :disabled="isDiscountDeclared" />
                            <el-button v-if="!isDiscountDeclared" @click="onFillFullAmt"> 全額 </el-button>
                        </div>
                    </el-form-item>
                    <el-form-item prop="foO_DIS_MEM" :label="`說明原因（必填）`">
                        <el-input v-model.trim="editForm.foO_DIS_MEM" :rows="3" type="textarea" maxlength="200" show-word-limit />
                    </el-form-item>
                    <el-form-item>
                        <el-alert
                            v-if="isDiscountDeclared"
                            style="line-height: 120%; margin-bottom: 20px;"
                            type="warning"
                            :title="`此折讓已申報 ${getPeriodText(invoice.foO_DIS_PREFIX_YER, invoice.foO_DIS_PREFIX_MONTH)} ，不可編輯折讓日期、折讓金額。`"
                            :closable="false"
                        />
                        <el-tooltip placement="top-start" trigger="hover" :disabled="!(isDiscountDeclared || isDeleteBtnDisabled)" :content="deleteBtnTooltipText">
                            <el-button v-if="invoice.foO_DIS" @click="onUndo" :loading="isEditLoading" :disabled="isDiscountDeclared || isDeleteBtnDisabled" type="danger" plain>移除折讓</el-button>
                        </el-tooltip>
                        <el-button type="" size="small" :loading="isEditLoading" @click="onEditCancel">
                            取消
                        </el-button>
                        <el-button type="primary" size="small" :loading="isEditLoading" class="primary-action" @click="onEditSubmit">
                            {{ confirmBtnText }}
                        </el-button>
                    </el-form-item>
                </el-form>
            </div>
        </div>
    </div>
</template>

<script>
import moment from 'moment';
import SpecView from '@/components/ui/SpecView/SpecView.vue';
import SpecItem from '@/components/ui/SpecView/SpecItem.vue';
import { eInvoicePlatformInfo } from '@/assets/commonData/options';

export default {
    props: {
        invoice: {
            type: Object,
            default: () => {},
        },
    },
    components: {
        SpecView,
        SpecItem,
    },
    watch: {
        invoice() {
            this.resetForm();
            this.isEditing = false;
        },
    },
    data() {
        // 自訂驗證 - 金額最大值
        const validateFooDisAmt = (rules, value, callback) => {
            if (parseFloat(value) > this.invoice.amt) {
                callback(new Error('不可大於發票含稅總計'));
            } else callback();
        };

        return {
            expend: true,
            isShowFooEditer: false,
            isEditLoading: false,
            isEditing: false,
            invoiceSerialInputValidate: false,
            fooChangeForm: {
                foo: null,
                foO_DAT: null,
            },
            editForm: {
                sno: null,
                foO_DIS_CNL: false,
                foO_DIS: 1,
                foO_DIS_AMT: 0,
                foO_DIS_DAT: Number(
                    moment()
                        .startOf('day')
                        .format('x'),
                ),
                foO_DIS_MEM: null,
            },
            editRules: {
                foO_DIS_DAT: [
                    {
                        required: true,
                        message: '請選擇日期',
                        trigger: 'change',
                    },
                ],
                foO_DIS_AMT: [
                    {
                        required: true,
                        message: '請選擇輸入金額',
                        trigger: 'blur',
                    },
                    { validator: validateFooDisAmt, trigger: 'blur' },
                ],
                foO_DIS_MEM: [
                    {
                        required: true,
                        message: '請填寫原因（必填）',
                        trigger: 'blur',
                    },
                ],
            },
        };
    },
    computed: {
        isVisiable() {
            if (this.isEditing) return true;
            if (this.invoice.status === 1 || this.invoice.typ === 4) return false;
            if (this.invoice && (this.invoice.foO_DIS === 1 || this.invoice.foO_DIS === 2) && this.invoice.foO_DIS_CNL === false) {
                return true;
            }
            return false;
        },
        isDiscountDeclared() {
            if (this.invoice && (this.invoice.foO_DIS === 1 || this.invoice.foO_DIS === 2) && this.invoice.foO_DIS_PREFIX_YER != null) {
                return true;
            }
            return false;
        },
        isShowEditButton() {
            if (this.invoice.e_InviceIsCanceled && this.invoice.foO_DIS_CNL) return false;
            if (this.isEditing) return false;

            if (this.isAuthOne(['B03']) && !this.isQR() && (this.invoice.status === 2 || this.invoice.status === 3 || this.invoice.status === 5)) {
                return true;
            }
            return false;
        },
        isShowReturnButton() {
            if (this.isEditing) return false;
            if (this.invoice.status === 5) return false;
            if (this.invoice.incomes.length > 0 && this.isAuthOne(['B03']) && !this.isQR()) return true;

            return false;
        },
        discountTypeText() {
            return this.invoice.foO_DIS_CNL ? '發票作廢' : '銷貨折讓';
        },
        editModeTypeText() {
            return this.editForm.foO_DIS_CNL ? '作廢' : '折讓';
        },
        deleteBtnText() {
            return this.invoice.foO_DIS_CNL ? '移除作廢' : '移除折讓';
        },
        isDeleteBtnDisabled() {
            const FOUND = this.invoice.incomes?.find((o) => o.flg < 0);
            return !!FOUND;
        },
        confirmBtnText() {
            return this.editForm.foO_DIS_CNL ? '確定作廢' : '儲存';
        },
        isDeleteDateValidate() {
            const CURR_MONTH = moment(this.invoice.foO_DAT).month() + 1;

            let year = moment().year();
            const month = (Math.ceil(CURR_MONTH / 2) * 2 + 1) % 12;
            if (CURR_MONTH > 10) year += 1;

            const DUE_DATE = moment()
                .year(year)
                .month(month - 1)
                .date(15)
                .startOf('day');

            return moment().isBefore(DUE_DATE);
        },
        isDeleteEditable() {
            return this.isDeleteDateValidate;
        },
        isEInvoiceCancelFlow() {
            return this.invoice.e_InvoiceDate && !this.invoice.e_InviceIsCanceled && this.editForm.foO_DIS_CNL && this.isEInvoicePlatformMatch;
        },
        isEInvoicePlatformMatch() {
            switch (this.eInvoicePlatform) {
            case 'EZPay':
                return this.invoice.e_InvoicePlatform === 1;
            case 'SunPay':
                return this.invoice.e_InvoicePlatform === 2;
            default:
                return false;
            }
        },
        invoicePlatform() {
            switch (this.invoice.e_InvoicePlatform) {
            case 1:
                return eInvoicePlatformInfo.ezPay;
            case 2:
                return eInvoicePlatformInfo.sunPay;
            default:
                return eInvoicePlatformInfo.none;
            }
        },
        eInvoicePlatform() {
            return this.$store.getters['menu/companyInfo'].eInvoiceInfo?.platform;
        },
        deleteBtnTooltipText() {
            if (this.isDiscountDeclared) return '此折讓已申報，無法移除';
            return '請先清除退款';
        },
    },
    methods: {
        disabledDate(date) {
            if (
                moment(date).isAfter(moment()) // 禁止未來日期
                || moment(date).isBefore(moment(this.invoice?.foO_DAT)) // 禁止發票開立前
            ) {
                return true;
            }

            return false;
        },
        startDiscount() {
            this.editForm.foO_DIS_CNL = false;
            this.isEditing = true;
        },
        onEdit() {
            this.editForm.sno = this.invoice.sno;
            this.editForm.foO_DIS_CNL = this.invoice.foO_DIS_CNL;
            this.editForm.foO_DIS = this.invoice.foO_DIS;
            this.editForm.foO_DIS_AMT = this.invoice.foO_DIS_AMT;
            this.editForm.foO_DIS_DAT = this.invoice.foO_DIS_DAT;
            this.editForm.foO_DIS_MEM = this.invoice.foO_DIS_MEM;
            this.isEditing = true;
        },
        resetForm() {
            this.editForm.sno = null;
            this.editForm.foO_DIS_CNL = false;
            this.editForm.foO_DIS = 1;
            this.editForm.foO_DIS_AMT = 0;
            this.editForm.foO_DIS_DAT = Number(
                moment()
                    .startOf('day')
                    .format('x'),
            );
            this.editForm.foO_DIS_MEM = null;
        },
        onEditCancel() {
            this.endEdit();
            this.editForm = {
                sno: null,
                foO_DIS_CNL: false,
                foO_DIS: 1,
                foO_DIS_AMT: 0,
                foO_DIS_DAT: Number(
                    moment()
                        .startOf('day')
                        .format('x'),
                ),
                foO_DIS_MEM: null,
            };
        },
        onEditFooDisChange(value) {
            if (value === 2) {
                this.editForm.foO_DIS_AMT = this.invoice.amt;
            }
        },
        onEditSubmit() {
            this.$refs.editForm.validate(async (valid) => {
                if (valid) {
                    try {
                        const eInvoiceDesc = this.invoice.e_InvoiceDate ? `請自行至「${this.invoicePlatform.label}電子發票加值服務平台」操作【折讓單通知】作業` : '';
                        const voidDesc = this.isEInvoiceCancelFlow ? `確認作廢此發票？（此發票將同步作廢${this.invoicePlatform.label}上的電子發票）` : '您確定已作廢當期發票？';

                        const confirmText = this.editForm.foO_DIS_CNL ? voidDesc : `確認送出銷貨折讓/作廢 ${this.editForm.foO_DIS_AMT} 元？${eInvoiceDesc}\n您確定已開立折讓單給買受人？`;

                        await this.$confirm(confirmText, {
                            confirmButtonText: '確定',
                            cancelButtonText: '取消',
                        });

                        this.submitDiscount();
                    } catch (e) {
                        console.log(e);
                    }
                }
            });
        },
        endEdit(needRefresh = false) {
            this.$emit('endEdit', needRefresh);
            this.isEditing = false;
        },

        async submitDiscount() {
            this.isEditLoading = true;
            console.log('submit discount', this.editForm);
            this.editForm.sno = this.invoice.sno;

            if (this.editForm.foO_DIS_AMT === this.invoice.amt) this.editForm.foO_DIS = 2;
            else this.editForm.foO_DIS = 1;

            if (this.isEInvoiceCancelFlow) await this.onDeleteEInvoice();
            else await this.onUpdateCreditNote();
        },
        async onDeleteEInvoice() {
            try {
                const resp = await this.deleteEInvoice(this.eInvoicePlatform);

                if (!resp.data.result) {
                    // eslint-disable-next-line no-throw-literal
                    throw { e: resp.data };
                }

                this.$message({
                    showClose: true,
                    message: '發票已作廢。',
                    type: 'success',
                });
            } catch ({ e }) {
                if (!e) return;

                let message = '';
                message += e.msg ? `Sokuji訊息：${e.msg}` : '';
                if (message !== '') message += '\n';
                message += e.vendor_msg ? `ezPay訊息：${e.vendor_msg}` : '';

                this.$msgbox({
                    title: '錯誤',
                    message,
                    confirmButtonText: '我瞭解了',
                    closeOnClickModal: false,
                });
            } finally {
                this.isEditLoading = false;
                this.endEdit(true);
            }
        },
        deleteEInvoice(platform) {
            let API;
            switch (platform) {
            case 'EZPay':
                API = 'CancelEzPayInvoice';
                break;
            case 'SunPay':
                API = 'CancelSunPayInvoice';
                break;
            default:
                break;
            }

            return this.$api_silent({
                url: `/InvoiceManagemnetPage/${API}`,
                method: 'POST',
                data: {
                    ioo: this.invoice.ioo,
                    invoiceNumber: this.invoice.foo,
                    reason: this.editForm.foO_DIS_MEM,
                },
            });
        },

        async onUpdateCreditNote() {
            try {
                await this.$api({
                    url: '/InvoiceManagemnetPage/UpdateCreditNote',
                    method: 'post',
                    data: this.editForm,
                });
                this.$message.success('銷貨折讓／作廢已登錄！');
            } finally {
                this.isEditLoading = false;
                this.endEdit(true);
            }
        },
        async onUndo() {
            try {
                await this.$confirm('確定要刪除銷貨折讓', {
                    confirmButtonText: '確定',
                    cancelButtonText: '取消',
                });
                this.submitUndo();
            } catch (e) {
                console.log(e);
            }
        },
        async submitUndo() {
            this.isEditLoading = true;
            try {
                await this.$api({
                    url: '/InvoiceManagemnetPage/UndoCreditNote',
                    method: 'post',
                    data: {
                        sno: this.invoice.sno,
                    },
                });
                this.endEdit();
            } finally {
                this.isEditLoading = false;
                this.endEdit(true);
            }
        },
        onFooDisCnlChange(val) {
            if (val) this.onFillFullAmt();
            else {
                this.editForm.foO_DIS_MEM = null;
                this.editForm.foO_DIS_AMT = 0;
            }
        },
        onFillFullAmt() {
            this.editForm.foO_DIS_AMT = this.invoice.amt;
        },
        formatFoo(foo) {
            if (!foo) return '--';
            return `${foo.slice(0, 2)}-${foo.slice(2)}`;
        },
        getPeriodText(year, month) {
            const monthList = ['1~2月', '3~4月', '5~6月', '7~8月', '9~10月', '11~12月'];
            if (year > 1911 && month >= 0 && month < 12) {
                return `${year - 1911}年 ${monthList[month - 1]}`;
            }
            return '';
        },
    },
};
</script>
